import React, { useEffect, useState } from 'react';
import { control, useForm } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router-dom';
import dayjs from 'dayjs';
import { Button, Box, Card } from '@mui/material';
import CustomerGold from '../../components/Forms/Gold/CustomerGold';
import { ViewTitle } from '../../components/ViewTitle';

export default function SaleBuy({ title, subtitle }) {
  const { control, handleSubmit, watch, getValues } = useForm();
  const history = useHistory();
  const location = useLocation();
  const place = location?.state;

  const handleBuy = (data) => {
    const cardID = getValues('cardID');
    if (!cardID || cardID.trim() === '') {
      alert('กรุณากรอกเลขบัตรประชาชนก่อนทำรายการซื้อ');
      return;
    } else if (cardID.length < 13) {
      alert('กรุณากรอกเลขบัตรประชาชนให้ครบ 13 หลัก');
      return;
    }
    history.push({
      pathname: '/gold/addProduct-buy',
      state: data,
      place: place || '',
    });
  };

  const handleSale = (data) => {
    const cardID = getValues('cardID');
    if (!cardID || cardID.trim() === '') {
      alert('กรุณากรอกเลขบัตรประชาชนก่อนทำรายการขาย');
      return;
    } else if (cardID.length < 13) {
      alert('กรุณากรอกเลขบัตรประชาชนให้ครบ 13 หลัก');
      return;
    }
    history.push({
      pathname: '/gold/addProduct-sale',
      state: data,
      place: place || '',
    });
  };
  const renderTitle = () => (
    <ViewTitle title={`${title} `} subtitle={subtitle} />
  );

  return (
    <div>
      {renderTitle()}
      {/* <Card> */}
      <Card className="p-4">
        <CustomerGold
          control={control}
          watch={watch}
          handleSubmit={handleSubmit}
        />
        {/* <div className="flex justify-center pt-4  ">
          <button className=" rounded-md  shadow-xl  p-4 bg-blue-500 transition delay-150 duration-300 ease-in-out hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500text-center text-white">
            อ่านจากเครื่องอ่านบัตร
          </button>
        </div> */}

        <Box
          sx={{ padding: 4, display: 'flex', justifyContent: 'space-evenly' }}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ">
            <div
              className="w-full p-8 bg-red-600 hover:bg-red-700 text-white text-2xl rounded-lg transition duration-700 ease-in-out transform hover:scale-110 cursor-pointer"
              onClick={handleSubmit(handleBuy)}
            >
              ซื้อ
            </div>
            <div
              className="w-full p-8 bg-green-600 hover:bg-green-700 text-white text-2xl rounded-lg transition duration-700 ease-in-out transform hover:scale-110 cursor-pointer"
              onClick={handleSubmit(handleSale)}
            >
              ขาย
            </div>
          </div>
        </Box>
      </Card>
      {/* </Card> */}
    </div>
  );
}
